import React, { useEffect } from "react";
import Visibility from "../utils/Visibility";
import CirclesMenu from "../MenusElements/CirclesMenu";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";
import Spacer from "../Spacer";
import LoadingMenusProduct from "./LoadingMenusProduct";

function RenderAndLoadingMenuCilrcles({
  loading,
  menus,
  selectedMenu,
  handleSelectChange,
  children,
}: {
  loading: boolean;
  menus: any;
  selectedMenu: any;
  handleSelectChange: any;
  children: any;
}) {
  useEffect(() => {
    if (menus.length !== 0) {
      const activeElement = document.querySelector(".menu-active");
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  }, [handleSelectChange, menus]);
  return (
    <div>
      <Visibility visible={!loading}>
        <div className="bg-primary rounded-b-3xl p-3 md:p-4 pb-5 md:pb-6 shadow-lg opacity-0 animate-fadeIn">
          <CirclesMenu
            data={menus}
            selectedMenu={selectedMenu}
            onClickMenu={handleSelectChange}
          />
        </div>
        <div className="opacity-0 animate-[fadeIn_0.3s_ease-out_0.2s_forwards]">
          {children}
        </div>
      </Visibility>
      <Visibility visible={loading}>
        <div className="flex-grow">
          {/* Loading Header */}
          <div className="bg-muted/50 rounded-b-3xl p-3 md:p-4 pb-5 md:pb-6">
            <div className="flex gap-3 md:gap-4 overflow-x-auto">
              <Iterator
                data={[1, 2, 3, 4, 5]}
                render={(_, index) => (
                  <Skeleton
                    key={index}
                    className="w-16 h-16 md:w-20 md:h-20 rounded-full flex-shrink-0"
                  />
                )}
              />
            </div>
          </div>
          
          <Spacer height={15} />
          
          {/* Loading Content */}
          <div className="flex flex-col gap-4 px-4">
            {/* Search Bar Skeleton */}
            <div className="flex gap-2 items-center">
              <Skeleton className="flex-1 h-11 rounded-full" />
              <Skeleton className="w-11 h-11 rounded-full" />
            </div>

            {/* Tabs Skeleton */}
            <div className="flex gap-3">
              <Iterator
                data={[1, 2, 3]}
                render={(_, index) => (
                  <Skeleton
                    key={index}
                    className="w-20 h-12 rounded-md"
                  />
                )}
              />
            </div>

            {/* Products Skeleton */}
            <div>
              <div className="flex gap-5 py-2">
                <Skeleton className="w-8 h-8 rounded-md" />
                <Skeleton className="w-8 h-8 rounded-md" />
              </div>
              <Spacer height={30} />
              <LoadingMenusProduct displayWaygrid={true} />
            </div>
          </div>
        </div>
      </Visibility>
    </div>
  );
}

export default RenderAndLoadingMenuCilrcles;
